export default __webpack_public_path__ + "static/5---What-Else-Should-You-Know-Before-Hiring-a-UX-Designer-f4a57759c2066ccbebe7960a71c8a017.png";